import Axios from "@/plugins/Axios";

class WebInfo {
  async pegarIpLocalDoUsuario() {
    const axios = Axios();

    const promises = [
      // axios.get("https://api.ipify.org?format=json").then((res) => res.data.ip),
      axios.get("https://checkip.amazonaws.com").then((res) => res.data.trim()),
    ];

    try {
      const ip = await Promise.any(promises);
      return ip || "sem_ip";
    } catch {
      return "sem_ip";
    }
  }

  pegarDispositivoDoUsuario() {
    try {
      const ua = navigator.userAgent;
      const hasTouch = navigator.maxTouchPoints > 0;

      // ANDROID (sempre primeiro) - Inclui detecção para modo desktop
      if (/Android/i.test(ua)) {
        return "Android";
      }

      // Android em modo desktop (userAgent modificado sem "Android" mas com touch)
      // Detecta Linux + touch + não é ChromeOS
      if (/Linux/i.test(ua) && hasTouch && !/CrOS/i.test(ua)) {
        return "Android";
      }

      // iOS (iPhone, iPad, iPod + iPadOS com UA de Mac)
      if (/iPhone|iPad|iPod/i.test(ua) || (ua.includes("Mac") && hasTouch)) {
        return "iOS";
      }

      // WINDOWS
      if (/Win/i.test(ua)) {
        return "Windows";
      }

      // MACOS (sem touch relevante)
      if (/Mac/i.test(ua) && !hasTouch) {
        return "MacOS";
      }

      // LINUX (desktop real - sem touch ou ChromeOS)
      if (/Linux/i.test(ua)) {
        return "Linux";
      }

      return "Desconhecido";
    } catch {
      return "Erro";
    }
  }

  pegarNavegadorDoUsuario() {
    try {
      const ua = navigator.userAgent;

      // ordem correta (mais específicos primeiro)
      if (ua.includes("Edg")) return "Edge";
      if (ua.includes("OPR") || ua.includes("Opera")) return "Opera";
      if (ua.includes("Arc")) return "Arc";
      if (ua.includes("Firefox")) return "Firefox";
      if (ua.includes("Chrome")) return "Chrome";
      if (ua.includes("Safari")) return "Safari";
      if (ua.includes("MSIE") || ua.includes("Trident")) return "Internet Explorer";

      return "Desconhecido";
    } catch {
      return "Erro";
    }
  }

  pegarVersaoNavegador() {
    try {
      const ua = navigator.userAgent;

      const getVersion = (regex) => {
        const match = ua.match(regex);
        return match ? match[1] : "desconhecida";
      };

      if (ua.includes("Edg")) return getVersion(/Edg\/(\d+\.\d+)/);
      if (ua.includes("OPR")) return getVersion(/OPR\/(\d+\.\d+)/);
      if (ua.includes("Arc")) return getVersion(/Arc\/(\d+\.\d+)/);
      if (ua.includes("Firefox")) return getVersion(/Firefox\/(\d+\.\d+)/);
      if (ua.includes("Chrome")) return getVersion(/Chrome\/(\d+\.\d+)/);
      if (ua.includes("Safari") && !ua.includes("Chrome")) return getVersion(/Version\/(\d+\.\d+)/);

      return "desconhecida";
    } catch {
      return "desconhecida";
    }
  }

  // 🔥 método consolidado (recomendado pra log/API)
  getInfoCompleta() {
    const ua = navigator.userAgent;

    return {
      os: this.pegarDispositivoDoUsuario(),
      browser: this.pegarNavegadorDoUsuario(),
      version: this.pegarVersaoNavegador(),
      isTouch: navigator.maxTouchPoints > 0,
      isMobile: /Mobi|Android|iPhone/i.test(ua),
      isTablet:
        /Tablet|iPad/i.test(ua) ||
        (navigator.maxTouchPoints > 0 && window.innerWidth >= 768 && window.innerWidth <= 1024),
      screen: {
        width: window.innerWidth,
        height: window.innerHeight,
      },
    };
  }
}

export default new WebInfo();
